import { render, staticRenderFns } from "./DetailUserCompanyPage.vue?vue&type=template&id=2cf0d768&"
import script from "./DetailUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./DetailUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports